import { DescrittoreSezione } from '../models/descrittore-sezione';

export class DescrittoriSezioneHash {
  [details: string]: DescrittoreSezione;
}
